import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import RecentBlogBox from "../../Component/BlogsCMPT/RecentBlogBox";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import { BlogCatFetchData, BlogLimitData } from "../../APIS/FetchAPIs";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import "./BlogCSS.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function BlogDetails() {
  const { blogslug } = useParams();
  const navigaṭe = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [ShowBlogData, setShowBlogData] = useState(true);

  const [LatestBlogLimit] = BlogLimitData(RendomTokenfetch);
  const [Blogcatdata] = BlogCatFetchData(RendomTokenfetch);
  // console.log(LatestBlogLimit);

  const FetchBlogData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(`${WebsiteAPIurl}blogDetailsAPI.php?blogslug=${blogslug}`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setBlogData(response.data.blogdata);
            // setShowBlogData(true);
          } else {
            setBlogData([]);
            // setShowBlogData(false);
          }
        });
    } catch (error) {
      console.error("API Error:", error);
      navigaṭe("/page-not-found", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, blogslug, navigaṭe]);

  useEffect(() => {
    FetchBlogData();
  }, [FetchBlogData, blogslug]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <title>{blogData.meta_title}</title>
        <meta name="description" content={blogData.meta_description} />
        <meta name="keywords" content={blogData.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename={blogData?.title} mainpage="blogs" />

      <section className="blog-single-content section-padding blog-single-page">
        <div className="container">
          <div className="row blog-with-sidebar">
            <div className="col col-lg-9 col-lg-push-3 col-md-8 col-md-push-4">
              <div className="post">
                <div className="post-title-meta">
                  {/* <h2>{blogData?.title}</h2> */}
                  <ul className="meta-info">
                    <li>
                      <a href="#;">Category: {blogData?.category}</a>
                    </li>
                    <li>
                      <a href="#;">
                        <i className="fa fa-user"></i> By: {blogData?.author}
                      </a>
                    </li>

                    <li>
                      <a href="#;">
                        <i className="fa fa-calendar-check-o"></i>{" "}
                        {blogData?.date}
                      </a>
                    </li>
                    <li>
                      <a href="#;">
                        <i className="fa fa-comments"></i>26 Comments
                      </a>
                    </li>
                  </ul>
                </div>
                <p>{blogData?.tagline}</p>
                <div
                  className="post-body"
                  dangerouslySetInnerHTML={{
                    __html: blogData.description,
                  }}
                ></div>
                <div
                  className="post-body"
                  dangerouslySetInnerHTML={{
                    __html: blogData.description2,
                  }}
                ></div>
              </div>

              <div className="tag-share">
                <div>
                  <span>Share:</span>
                  <ul className="share">
                    <li>
                      <a href="#;">
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#;">
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#;">
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>

                    <li>
                      <a href="#;">
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* <div className="comments">
                <ol>
                  <li>
                    <div className="article">
                      <div className="author-pic">
                        <img
                          src="images/blog-single/comments/img-1.html"
                          alt=""
                        />
                      </div>
                      <div className="details">
                        <div className="author-meta">
                          <div className="name">
                            <h4>Hasib sharif</h4>
                          </div>
                          <div className="date">
                            <span>2 hours ago</span>
                          </div>
                        </div>
                        <div className="comment-content">
                          <p>
                            There are many variations of passages of Lorem Ipsum
                            available, but the majority have suffered alteration
                            in some form, by injected humour, or randomised
                            words which don't look even slightly believable.{" "}
                          </p>
                        </div>
                        <div className="replay">
                          <button>Replay</button>
                        </div>
                      </div>
                    </div>
                    <ol>
                      <li>
                        <div className="article">
                          <div className="author-pic">
                            <img
                              src="images/blog-single/comments/img-2.html"
                              alt=""
                            />
                          </div>
                          <div className="details">
                            <div className="author-meta">
                              <div className="name">
                                <h4>Ahmad sharif</h4>
                              </div>
                              <div className="date">
                                <span>2 hours ago</span>
                              </div>
                            </div>
                            <div className="comment-content">
                              <p>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have suffered
                                alteration in some form, by injected humour, or
                                randomised words which don't look even slightly
                                believable.{" "}
                              </p>
                            </div>
                            <div className="replay">
                              <button>Replay</button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="article">
                          <div className="author-pic">
                            <img
                              src="images/blog-single/comments/img-2.html"
                              alt=""
                            />
                          </div>
                          <div className="details">
                            <div className="author-meta">
                              <div className="name">
                                <h4>Ahmad sharif</h4>
                              </div>
                              <div className="date">
                                <span>2 hours ago</span>
                              </div>
                            </div>
                            <div className="comment-content">
                              <p>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have suffered
                                alteration in some form, by injected humour, or
                                randomised words which don't look even slightly
                                believable.{" "}
                              </p>
                            </div>
                            <div className="replay">
                              <button>Replay</button>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ol>
                  </li>

                  <li>
                    <div className="article">
                      <div className="author-pic">
                        <img
                          src="images/blog-single/comments/img-1.html"
                          alt=""
                        />
                      </div>
                      <div className="details">
                        <div className="author-meta">
                          <div className="name">
                            <h4>Hasib sharif</h4>
                          </div>
                          <div className="date">
                            <span>2 hours ago</span>
                          </div>
                        </div>
                        <div className="comment-content">
                          <p>
                            There are many variations of passages of Lorem Ipsum
                            available, but the majority have suffered alteration
                            in some form, by injected humour, or randomised
                            words which don't look even slightly believable.{" "}
                          </p>
                        </div>
                        <div className="replay">
                          <button>Replay</button>
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>

                <div className="comment-respond">
                  <h3>Post your comment</h3>
                  <form className="clearfix">
                    <div className="col col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="username.."
                      />
                    </div>
                    <div className="col col-md-4">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="email address.."
                      />
                    </div>
                    <div className="col col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="website.."
                      />
                    </div>
                    <div className="col col-xs-12">
                      <textarea
                        className="form-control"
                        placeholder="write.."
                      ></textarea>
                    </div>
                    <div className="comment-respond-submit">
                      <button type="submit" className="btn theme-btn">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>

            <div className="blog-sidebar col col-lg-3 col-lg-pull-9 col-md-4 col-md-pull-8 col-sm-5 sticky-sidebar">
              <div className="widget search-widget">
                <form className="form">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search here.."
                  />
                </form>
              </div>
              <div className="widget category-widget">
                <h3>Category</h3>
                <ul>
                  {loading ? (
                    <p className="text-center">Loading blogs...</p>
                  ) : Blogcatdata.length > 0 ? (
                    Blogcatdata.map((valblog, index) => (
                      <li key={index}>
                        <Link to="/blogs">
                          <i
                            className="fa fa-arrow-right"
                            aria-hidden="true"
                          ></i>

                          {valblog.title}
                          {/* <span className="badge">12</span> */}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <p className="text-center">No blogs available right now.</p>
                  )}
                </ul>
              </div>
              <div className="widget recent-post-widget">
                <h3>Recent post</h3>
                <ul>
                  {loading ? (
                    <p className="text-center">Loading blogs...</p>
                  ) : LatestBlogLimit.length > 0 ? (
                    LatestBlogLimit.map((valblog, index) => (
                      <RecentBlogBox key={index} blogdata={valblog} />
                    ))
                  ) : (
                    <p className="text-center">No blogs available right now.</p>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
